import React from "react";
import { HeaderNavLink } from "..";

type ProfileNavProps = {
  isActive: any;
  setIsActive: any;
};
const ProfileNav: React.FC<ProfileNavProps> = ({ isActive, setIsActive }) => {
  const handleActive = (
    pageName: "Posts" | "Like" | "Photos" | "Community"
  ) => {
    setIsActive(pageName);
  };

  return (
    <div className="w-full border-t border-solid border-[#969696] lg:pt-2 lg:py-0 py-4">
        <ul className="flex text-base bg-[#2157590F] lg:bg-inherit rounded-lg lg:rounded-none font-Inter h-10 text-center items-center">
          <HeaderNavLink
            active={isActive === "Posts"}
            onClick={() => handleActive("Posts")}
          >
            Posts
          </HeaderNavLink>
          <HeaderNavLink
            active={isActive === "Like"}
            onClick={() => handleActive("Like")}
          >
            Like
          </HeaderNavLink>
          {/* <HeaderNavLink
          active={isActive === 'Friends'}
          onClick= {() => handleActive('Friends')}
        >
          Friends
        </HeaderNavLink> */}
          <HeaderNavLink
            active={isActive === "Photos"}
            onClick={() => handleActive("Photos")}
          >
            Photos
          </HeaderNavLink>
          <HeaderNavLink
            active={isActive === "Community"}
            onClick={() => handleActive("Community")}
          >
            Community
          </HeaderNavLink>
        </ul>
      </div>
  );
};

export default ProfileNav;
